import React from 'react';

import { Box } from '@tf/ui';
import { S } from '@tf/utils';

import type { CaseRequestStatus, CaseStatus } from '@/core/types/cases';

export const CaseStatusBadge: React.FC<{
	caseStatus: CaseStatus;
	caseRequestStatus: CaseRequestStatus;
}> = ({ caseStatus, caseRequestStatus }) => {
	// Emulating old behavior where we have single status
	const status = caseStatus !== 'CLOSED' ? caseRequestStatus : caseStatus;

	return (
		<Box
			sx={{
				display: 'inline-block',
				padding: '0 8px',
				borderRadius: '20px',
				...(status !== 'CLOSED' && status !== 'DRAFT'
					? {
							color: '#164CB0',
							backgroundColor: '#EFF4FF',
					  }
					: {
							color: '#2B2B2B',
							backgroundColor: '#F3F3F3',
					  }),
			}}
		>
			{S.prettify(status)}
		</Box>
	);
};
